const es = {
  nav: {
    dashboard: "Panel",
    messages: "Bandeja",
    calls: "Llamadas",
    calendar: "Calendario",
    automations: "Automatizaciones",
    marketing: "Marketing",
    orders: "Pedidos",
    customers: "Clientes",
    analytics: "Insights",
    settings: "Ajustes",
    integrations: "Integraciones",
    notifications: "Notificaciones",
    logout: "Salir",
    products: "Productos",
    tasks: "Tareas",
    billing: "Facturación",
    support: "Soporte",
    myBusiness: "Mi negocio",
    restaurantEditor: "Editor Restaurante",
    liveRoom: "Sala en vivo",
    myProfile: "Mi Perfil",
    team: "Equipo",
    help: "Ayuda",
    ai: "IA Assistant",
    logs: "Logs",
    alerts: "Alertas",
    whatsapp: "WhatsApp",
  },

  common: {
    loading: "Cargando...",
    save: "Guardar",
    saving: "Guardando...",
    saved: "Guardado",
    error: "Error",
    openNavigation: "Abrir navegación",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    search: "Buscar",
    filter: "Filtrar",
    actions: "Acciones",
    status: "Estado",
    type: "Tipo",
    name: "Nombre",
    email: "Email",
    phone: "Teléfono",
    date: "Fecha",
    total: "Total",
    empty: "Sin resultados",
    perPage: "Por página",
    purchases: "Compras",
    whatsapp: "WhatsApp",
    noData: "No hay datos",
    back: "Volver",
    next: "Siguiente",
    previous: "Anterior",
    yes: "Sí",
    no: "No",
    confirm: "Confirmar",
    close: "Cerrar",
    open: "Abrir",
    add: "Añadir",
    remove: "Quitar",
    update: "Actualizar",
    creating: "Creando...",
    updating: "Actualizando...",
    deleting: "Eliminando...",
    created: "Creado",
    updated: "Actualizado",
    deleted: "Eliminado",
    viewAll: "Ver todos",
    manage: "Gestionar",
    all: "Todos",
    manual: "Manual",
    bookings: "Reservas",
    booking: "Reserva",
    of: "de",
    page: "Pág.",
    noResults: "Sin resultados",
    view: "Ver",
    online: "En línea",
    offline: "Desconectado",
    origin: "Origen",
    optional: "opcional",
    create: "Crear",
    select: "Seleccionar",
    filters: "Filtros",
  },

  topbar: {
    client: "Cliente",
    profile: "Perfil",
    logout: "Cerrar sesión",
    defaultClient: "Por defecto",
  },

  status: {
    online: "En línea",
    offline: "Desconectado",
    pending: "Pendiente",
    completed: "Completado",
    cancelled: "Cancelado",
    processing: "Procesando",
    shipped: "Enviado",
    delivered: "Entregado",
    refunded: "Reembolsado",
    confirmed: "Confirmada",
    paid: "Pagado",
    onHold: "En espera",
    failed: "Fallido",
    pendingArrival: "En camino 🟠",
    checkedIn: "Check-in",
    inHouse: "En casa",
    checkedOut: "Check-out",
    noShow: "No Show",
  },

  time: {
    now: "Ahora",
    minutesAgo: "Hace {{count}}m",
    hoursAgo: "Hace {{count}}h",
    daysAgo: "Hace {{count}}d",
    minutes_short: "m",
    hours_short: "h",
    days_short: "d",
  },

  customers: {
    title: "Clientes",
    subtitle: "Clientes de WhatsApp, tienda online y añadidos manualmente",
    detail: "Detalle del cliente",
    newCustomer: "Nuevo cliente",
    editCustomer: "Editar cliente",
    backToCustomers: "Volver a clientes",
    createOffer: "Crear oferta",
    deleteTitle: "¿Eliminar cliente?",
    deleteConfirm: "Se eliminará {{name}}. Esta acción no se puede deshacer.",
    thisCustomer: "este cliente",
    noName: "Sin nombre",
    searchPlaceholder: "Nombre, email o teléfono…",
    noResultsWithFilters: "No se encontraron clientes con los filtros aplicados",
    totalSpent: "Total gastado",
    segments: {
      all: "Todos los segmentos",
      new: "Nuevos (≤1 pedido)",
      recurring: "Recurrentes (≥2)",
      inactive: "Inactivos (+60d)",
      topSpenders: "Más gasto",
      topOrders: "Más pedidos",
      recent: "Más recientes",
    },
    table: {
      name: "Nombre",
      customer: "Cliente",
      contact: "Contacto",
      totalSpent: "Total gastado",
      orders: "Pedidos",
      lastActivity: "Última actividad",
      actions: "Acciones",
      origin: "Origen",
    },
    contactMissing: "Sin datos de contacto",
    empty: "Sin clientes",
    noBookings: "Sin reservas",
    perPage: "Por página",
    filters: {
      channel: "Canal",
      date: "Fecha",
    },
    details: {
      contactInfo: "Información de contacto",
      orderHistory: "Historial de pedidos",
      notes: "Notas",
      totalSpent: "Gasto total",
      lifetimeValue: "Valor de vida",
      averageOrder: "Pedido promedio",
      averageTicket: "Ticket medio",
      firstOrder: "Primer pedido",
      lastOrder: "Último pedido",
      lastMessage: "Último mensaje",
      registered: "Registrado",
      recentActivity: "Actividad reciente",
      ordersOrBookings: "Pedidos/Reservas",
      viewAllOrders: "Ver todos los pedidos",
      note: "Nota",
      tags: "Etiquetas",
    },
    placeholders: {
      name: "Mohamed Alami",
      email: "cliente@email.com",
      phone: "+212 6XX XXX XXX",
      notes: "Notas sobre este cliente...",
      addTag: "Añadir etiqueta y pulsar Enter…",
      writeNote: "Escribe una nota sobre este cliente…",
    },
    errors: {
      atLeastOneField: "Añade al menos nombre, email o teléfono",
    },
  },

  orders: {
    title: "Pedidos",
    detail: "Detalle del pedido",
    unifiedDescription: "Listado unificado — WooCommerce, Shopify y PrestaShop.",
    searchPlaceholder: "Buscar #pedido, cliente, email…",
    ordersCount: "pedidos",
    showing: "Mostrando",
    loadingDetail: "Cargando detalle…",
    reminder: "Recordatorio",
    return: "Devolución",
    returnType: "Devolución",
    exchangeType: "Cambio",
    createRequest: "Crear solicitud",
    reminderWhat: "¿Qué hay que hacer?",
    reminderPlaceholder: "Ej: Enviar pedido la semana que viene",
    reasonPlaceholder: "Describe el motivo de la devolución o cambio…",
    notFound: "Pedido no encontrado",
    table: {
      order: "Pedido",
      date: "Fecha",
      customer: "Cliente",
      total: "Total",
      status: "Estado",
      items: "Artículos",
      origin: "Origen",
      actions: "Acciones",
      view: "Ver",
    },
    empty: "Sin pedidos",
    perPage: "Por página",
    shipping: "Envío",
    refundRequest: "Solicitud de devolución / cambio",
    internalNotes: "Notas internas",
    newReminder: "Nuevo recordatorio",
    reminderDateTime: "Fecha / hora (opcional)",
    reason: "Motivo",
    history: "Historial",
    purchases: "Compras",
    totalSpent: "Gasto total",
    nameAZ: "Nombre A-Z",
    filters: {
      allOrders: "Todos los pedidos",
      pending: "Pendientes",
      processing: "En proceso",
      completed: "Completados",
      cancelled: "Cancelados",
      dateRange: "Rango de fechas",
    },
    details: {
      orderInfo: "Información del pedido",
      customerInfo: "Información del cliente",
      items: "Artículos",
      shippingAddress: "Dirección de envío",
      billingAddress: "Dirección de facturación",
      paymentMethod: "Método de pago",
      shippingMethod: "Método de envío",
      subtotal: "Subtotal",
      shippingCost: "Gastos de envío",
      taxes: "Impuestos",
      discount: "Descuento",
      total: "Total",
    },
    errors: {
      cannotSaveStatus: "No se pudo guardar el estado",
      cannotSaveReminder: "Error al guardar el recordatorio",
      cannotCreateReturn: "Error al crear la solicitud",
    },
  },

  dashboard: {
    title: "Panel de Control",
    subtitle: "Resumen en tiempo real de tu negocio",
    whatsappMessages: "Mensajes WhatsApp",
    totalCustomers: "Clientes totales",
    recentMessages: "Mensajes recientes",
    latestOrders: "Últimos pedidos",
    latestBookings: "Últimas reservas",
    activity: "Actividad",
    messages: "Mensajes",
    runs: "Runs",
    success: "Éxito",
    contacts: "contactos",
    new: "nuevos",
    people: "personas",
    upcoming: "Próximas",
    appointments: "Citas",
    bookings: "Reservas",
    patients: "Pacientes",
    newThisPeriod: "nuevos este período",
    noRecentMessages: "Sin mensajes recientes",
    noRecentOrders: "Sin pedidos recientes",
    noRecentBookings: "Sin reservas recientes",
    noText: "(sin texto)",
    createFirstAutomation: "Crear primera automatización →",
    last7Days: "7 días",
    last30Days: "30 días",
    nucleo: "Núcleo",
    dispatches: "Envíos",
    totalProcessedEvents: "Total de eventos procesados",
    successfulDispatches: "Envíos Exitosos",
    matchedStatusDesc: "Dispatches con estado 'matched'",
    failedDispatches: "Envíos Fallidos",
    errorStatusDesc: "Dispatches con estado 'error'",
    skippedDispatches: "Omitidos / Duplicados",
    skippedStatusDesc: "Dispatches con estado 'skipped'",
    operationalMonitoring: "Monitorización Operativa",
    noRecentEvents: "No hay eventos recientes.",
    aiTrigger: "AI Trigger",
    regexFallback: "Regex Fallback",
    event: "Evento",
    crm: {
      title: "CRM",
      contacts: "Contactos",
      newContact: "Nuevo contacto",
      searchPlaceholder: "Buscar por nombre, teléfono o email...",
      allStages: "Todas las etapas",
      loadingContacts: "Cargando contactos...",
      noContactsFound: "No se encontraron contactos",
      adjustFilters: "Intenta ajustar los filtros de búsqueda",
      totalContacts: "Total Contactos",
      openDeals: "Deals Abiertos",
      pipelineValue: "Valor Pipeline",
      recentActivity: "Actividad Reciente",
      segments: "Segmentos",
      pipelines: "Embudos",
      customerProfile: "Perfil del Cliente",
      quickView: "CRM Quick View",
      noLinkedContact: "Sin vínculo CRM",
      linkContactHint: "Este chat no está asociado a un contacto. Vincula la identidad para ver métricas y deals.",
      linkContact: "Vincular contacto",
      aiInsight: "AI Insight",
      analyzingProfile: "Analizando perfil del cliente...",
      stage: "Etapa",
      fastNote: "Nota rápida",
      internalNotePlaceholder: "Añadir nota interna...",
      saveNote: "Guardar",
      viewFullProfile: "Ir al Perfil Completo",
      lastContact: "Último contacto",
      information: "Información",
      phone: "Teléfono",
      email: "Email",
      company: "Empresa",
      tags: "Etiquetas",
      editTags: "Editar",
      noTags: "Sin etiquetas",
      addInternalNote: "Añadir nota interna",
      writeSomething: "Escribe algo sobre este contacto...",
      saving: "Guardando...",
      saveNoteBtn: "Guardar nota",
      noActivity: "No hay actividad registrada.",
      timeline: {
        note: "Nota",
        message: "Mensaje",
        campaign: "Campaña",
        deal: "Oportunidad",
        booking: "Reserva",
        stageChange: "Cambio de etapa",
        system: "Sistema",
        inbound: "Entrante",
        outbound: "Saliente"
      },
      newOpportunity: "Nueva Oportunidad",
      deleteContact: "Eliminar contacto",
      contactNotFound: "Contacto no encontrado",
      backToCrm: "Volver al CRM"
    }
  },

  marketing: {
    newCampaign: "Nueva campaña",
    email: "Email",
    sms: "SMS",
    whatsapp: "WhatsApp",
    social: "Redes sociales",
    scheduled: "Programado",
    sent: "Enviado",
    subtitle: "Plantillas y campañas para {{name}}",
    yourBusiness: "tu negocio",
    newTemplate: "Nueva plantilla",
    editTemplate: "Editar plantilla",
    createTemplate: "Crear plantilla",
    templateUpdated: "Plantilla actualizada",
    templateCreated: "Plantilla creada",
    templateDeleted: "Plantilla eliminada",
    errorDeleting: "Error al eliminar",
    confirmDelete: "¿Eliminar esta plantilla?",
    varsHint: "Las variables se detectan automáticamente con {{variable}}",
    templateName: "Nombre de la plantilla",
    subject: "Asunto",
    message: "Mensaje",
    characters: "caracteres",
    detectedVars: "Variables detectadas",
    variableLabel: "Etiqueta",
    allowReplies: "Permitir respuestas del cliente",
    launchCampaign: "Lanzar campaña",
    campaignName: "Nombre de la campaña",
    audienceSegment: "Segmento de audiencia",
    templateVars: "Variables de la plantilla",
    preview: "Vista previa",
    scheduleSend: "Programar envío",
    reach: "Alcance est.",
    sendType: "Envío",
    immediate: "Inmediato",
    replies: "Respuestas",
    allowed: "Permitidas",
    disabled: "Desactivadas",
    schedule: "Programar",
    sendNow: "Enviar ahora",
    yours: "Tuya",
    campaignLaunched: "Campaña lanzada a ~{{count}} contactos",
    searchPlaceholder: "Buscar plantillas...",
    templates: "plantillas",
    template: "plantilla",
    loading: "Cargando plantillas...",
    yourTemplates: "Tus plantillas",
    new: "Nueva",
    noOwnTemplates: "Sin plantillas propias",
    createFirstHint: "Crea tu primera plantilla personalizada",
    zepelinTemplates: "Plantillas de Zepelin",
    available: "disponibles",
    zepelinTemplatesDesc: "Plantillas profesionales creadas por el equipo Zepelin. Se actualizan con nuevas festividades y tendencias. Solo lectura — úsalas directamente o como base para las tuyas.",
    segments: {
      all: "Todos los contactos",
      allDesc: "Base completa del CRM",
      recent30: "Últimos 30 días",
      recent30Desc: "Contactos creados recientemente",
      recent90: "Últimos 90 días",
      recent90Desc: "Clientes del trimestre",
      withBookings: "Con reservas",
      withBookingsDesc: "Han hecho al menos una reserva",
      noShow: "No-shows",
      noShowDesc: "No aparecieron a su reserva",
      vip: "VIP (3+ reservas)",
      vipDesc: "Clientes frecuentes",
    },
    placeholders: {
      emailBody: "Hola {{nombre}},\n\nEsperamos que estés bien...",
      whatsappBody: "Hola {{nombre}}, te recordamos tu reserva para mañana a las {{hora}}...",
      templateName: "Ej: Recordatorio reserva cena",
      subject: "Asunto del email",
    },
    stats: {
      total: "Total contactos",
      withEmail: "Con email",
      withPhone: "Con teléfono",
      new30d: "Nuevos 30d",
    },
    history: "Historial de Campañas",
    campaignHistory: "Historial de Campañas",
    eligible: "elegibles",
    destinatarios: "destinatarios",
    reach_est: "Alcance est.",
    plantillas: "Plantillas",
  },

  analytics: {
    title: "Analytics",
    overview: "Resumen",
    revenue: "Ingresos",
    today: "Hoy",
    yesterday: "Ayer",
    noChange: "Sin cambio",
    vsPrevious: "vs período anterior",
    noDataPeriod: "Sin datos en este período",
    last7Days: "últimos 7 días",
    last30Days: "últimos 30 días",
    updating: "Actualizando...",
    updatedAt: "Actualizado {{time}}",
    loading: "Cargando...",
    "7days": "7 días",
    "30days": "30 días",
    totalMessages: "Mensajes totales",
    messagesSummary: "{{in}} recibidos · {{out}} enviados",
    conversations: "Conversaciones",
    uniqueThreads: "Hilos únicos",
    newContacts: "Contactos nuevos",
    crmTotal: "{{count}} total en CRM",
    confirmedBookings: "Reservas confirmadas",
    bookingsSummary: "{{cancelled}} canceladas · {{pending}} pendientes",
    messageActivity: "Actividad de mensajes",
    sent: "Enviados",
    received: "Recibidos",
    templates: "Plantillas",
    failed: "Fallidos",
    estimatedCost: "Coste estimado",
    contactBase: "Base de contactos",
    withEmail: "Con email",
    withPhone: "Con teléfono",
    newThisWeek: "Nuevos esta semana",
    totalCrm: "Total CRM",
    activePlan: "Plan activo",
    month: "mes",
    noActiveSubscription: "Sin suscripción activa",
    voiceBalance: "Saldo voz",
    min: "min",
    smsBalance: "Saldo SMS",
    campaigns: "Campañas",
    messagingChannels: "Canales de mensajería",
    bookingStatus: "Estado de reservas",
    noBookings: "Sin reservas registradas",
    totalHistory: "Total histórico",
  },

  calendar: {
    title: "Calendario",
    loading: "Cargando calendario...",
    personalAgenda: "Agenda personal",
    stayManagement: "Gestión de estancias",
    consultationManagement: "Gestión de consultas",
    appointmentManagement: "Gestión de citas",
    bookingManagement: "Gestión de reservas",
    weekOf: "Semana del",
    more: "más",
    appointmentsThisWeek: "citas esta semana",
    newAppointment: "Nueva cita",
    today: "Hoy",
    month: "Mes",
    week: "Semana",
    day: "Día",
    agenda: "Agenda",
    events: "Eventos",
    newEvent: "Nuevo evento",
    editEvent: "Editar evento",
    deleteEvent: "Eliminar evento",
    eventDetails: "Detalles del evento",
    allDay: "Todo el día",
    starts: "Inicia",
    ends: "Termina",
    repeat: "Repetir",
    location: "Ubicación",
    description: "Descripción",
    attendees: "Asistentes",
    addAttendee: "Añadir asistente",
    reminders: "Recordatorios",
    previous: "Anterior",
    next: "Siguiente",
    hour: "Hora",
    addEvent: "Añadir {{event}}",
    checkin: "Check-in",
    checkout: "Check-out",
    inHouse: "En casa",
    roomMap: "Mapa de habitaciones",
    freeRoom: "Habitación libre",
    bookedVia: "Reservado vía",
    createdOn: "Creada el",
    deletePermanently: "Eliminar permanentemente",
    selectedDay: "Día seleccionado",
    allStatuses: "Todos los estados",
    active: "Activos",
    cancelledNoShow: "Cancelados / No show",
    exportCsv: "Exportar CSV",
    new: "Nueva",
    ofTheDay: "del día",
    clickForDetails: "click para ver detalle",
    noEventsForDay: "No hay {{event}}s para este día",
    tablePlaceholder: "Ej: 2 → Mesa 2",
    startTime: "Hora inicio",
    endTime: "Hora fin",
    duration: "Duración",
    professional: "Profesional",
    professionalPlaceholder: "Nombre del profesional",
    service: "Servicio",
    servicePlaceholder: "Manicura, Masaje...",
    department: "Departamento",
    departmentPlaceholder: "Cardiología...",
    doctor: "Médico",
    doctorPlaceholder: "Dr. Apellido",
    patientName: "Nombre del Paciente",
    patientPlaceholder: "Mohamed El Fassi",
    clientName: "Nombre del Cliente",
    clientPlaceholder: "Amina El Khattabi",
    guestName: "Nombre del Huésped",
    guestPlaceholder: "Familia Bensouda",
    bookingName: "Nombre de la Reserva",
    bookingPlaceholder: "Reserva cumpleaños",
    editAppointment: "Editar cita",
    titleSubject: "Título / Asunto",
    titlePlaceholder: "Ej: Reunión con cliente, Consultoría...",
    notesPlaceholder: "Cualquier detalle relevante...",
    hours: "horas",
    appointment: "cita",
    room: "Hab.",
    guests: "huéspedes",
    pax: "Pax",
    tableRoom: "Mesa/Hab",
    start: "Inicio",
    end: "Fin",
    title: "Título",
    bookingHistory: "Historial de reservas",
    noBookingsRegistered: "Sin reservas registradas",
    paxShort: "pers.",
    table: "Mesa",
  },

  messages: {
    title: "Mensajes",
    threads: "Hilos",
    noThreads: "No hay conversaciones",
    noSubject: "(sin asunto)",
    selectThread: "Selecciona un hilo",
    noMessages: "No hay mensajes",
    you: "yo",
    contact: "contacto",
    typeMessage: "Escribe un mensaje…",
    send: "Enviar",
    sending: "Enviando...",
    inbox: "Bandeja de entrada",
    sent: "Enviados",
    drafts: "Borradores",
    archived: "Archivados",
    spam: "Spam",
    trash: "Papelera",
    compose: "Redactar",
    reply: "Responder",
    forward: "Reenviar",
    delete: "Eliminar",
    markAsRead: "Marcar como leído",
    markAsUnread: "Marcar como no leído",
    archive: "Archivar",
    search: "Buscar mensajes...",
    selectConversation: "Selecciona una conversación",
    attachments: "Archivos adjuntos",
    messageSent: "Mensaje enviado",
    messageFailed: "Error al enviar mensaje",
    sendMessage: "Enviar mensaje",
    sendTemplate: "Enviar plantilla",
    previews: {
      noMessages: "Sin mensaje reciente",
      audio: "Audio",
      image: "Imagen",
      video: "Vídeo",
      location: "Ubicación",
      document: "Documento",
      template: "Plantilla",
    },
    header: {
      aiPaused: "🤖 IA pausada — modo manual activado",
      aiReactivated: "🤖 IA reactivada",
      aiError: "Error al cambiar estado de IA",
      resolved: "Resuelta",
      reopened: "Reabierta",
      archived: "Archivada",
      unarchived: "Desarchivada",
      addedFromInbox: "Añadido desde bandeja",
      contactSaved: "Contacto guardado",
      saveError: "Error al guardar",
      addContact: "Añadir contacto",
      editContact: "Editar contacto",
      contactNamePlaceholder: "Nombre del contacto",
      saveContact: "Guardar contacto",
      conversation: "Conversación",
      reopen: "Reabrir",
      resolve: "Resolver",
      unarchive: "Desarchivar",
      archive: "Archivar",
      pauseAiHint: "Pausar IA y responder manualmente",
      pauseAi: "Pausar IA",
      activateAiHint: "Reactivar IA",
      activateAi: "Activar IA",
      closeConversation: "Cerrar conversación",
    },
    input: {
      addDescription: "Añadir descripción...",
      fileTooLarge: "es demasiado grande",
      attachError: "Error al adjuntar archivo",
      sendError: "Error al enviar",
      placeholder: "Escribe un mensaje...",
    },
    templates: {
      title: "Enviar plantilla WhatsApp",
      loading: "Cargando plantillas...",
      none: "No hay plantillas aprobadas",
      select: "Selecciona una plantilla",
      variables: "variables",
      change: "Cambiar plantilla",
      variable: "Variable",
      valueFor: "Valor para",
      preview: "Vista previa",
      sent: "Plantilla enviada",
      sendError: "Error al enviar plantilla",
    },
    location: {
      title: "Enviar ubicación",
      searchPlaceholder: "Buscar lugar...",
      useCurrent: "Usar mi ubicación actual",
      gettingLocation: "Obteniendo ubicación...",
      searchError: "Error al buscar ubicación",
      geoNotAvailable: "Geolocalización no disponible",
      geoError: "No se pudo obtener la ubicación",
      sent: "Ubicación enviada",
      sendError: "Error al enviar ubicación",
      change: "← Cambiar ubicación",
      map: "Mapa",
      mapNotAvailable: "Mapa no disponible",
      viewOnMaps: "Ver en Google Maps",
    },
    bubbles: {
      download: "Descargar",
      tapToDownload: "Toca para descargar",
      retry: "Reintentar",
      sharedLocation: "Ubicación compartida",
      whatsappTemplate: "Plantilla de WhatsApp",
    },
    voice: {
      error: "No se pudo acceder al micrófono",
      recording: "Grabando...",
      label: "Grabar mensaje de voz",
    }
  },

  integrations: {
    title: "Integraciones",
    subtitle: "Conecta tus herramientas favoritas y automatiza tus flujos de trabajo",
    loadingAccount: "Obteniendo información de tu cuenta",
    noActiveSession: "No hay sesión activa",
    noTenantFound: "No se ha encontrado un tenant válido. Por favor, inicia sesión nuevamente.",
    goToLogin: "Ir a login",
    activeTenant: "Tenant activo",
    connected: "Conectadas",
    syncing: "Sincronizando",
    failed: "Fallidas",
    searchPlaceholder: "Buscar integración…",
    noIntegrationsFound: "No se encontraron integraciones",
    tryDifferentSearch: "Prueba con otros términos de búsqueda o selecciona otra categoría",
    noIntegrationsAvailable: "No hay integraciones disponibles en este momento",
    disconnect: "Desconectar",
    disconnectConfirm: "¿Estás seguro de que quieres desconectar esta integración?",
    needIntegration: "¿Necesitas una integración que no encuentras?",
    contactUs: "Contáctanos para desarrollarla",
    configure: "Configurar",
    settings: "Configuración",
    status: "Estado",
    lastSync: "Última sincronización",
    sync: "Sincronizar",
    syncingStatus: "Sincronizando...",
    connect: "Conectar",
    connecting: "Conectando...",
    disconnecting: "Desconectando...",
    configureFirst: "Configurar primero",
    configureIntegration: "Configurar {{name}}",
    saveAndConnect: "Guardar y conectar",
    notConnected: "No conectado",
    oauthAuth: "Autenticación OAuth",
    credentials: "Credenciales",
    secureAuth: "✨ Autorización segura",
    oauthDescription: "Haz clic en \"Conectar\" y serás redirigido a {{name}} para autorizar el acceso.",
    oauthBenefits: {
      noExposure: "✓ Sin exposición de credenciales",
      secure: "✓ Seguro y encriptado",
      revocable: "✓ Revocable en cualquier momento",
    },
    noCredentialsRequired: "No se requieren credenciales adicionales.",
    testConnection: "Probar Conexión",
    connectionSuccessful: "Conexión exitosa. Las credenciales son válidas.",
    connectionError: "Error de conexión. Verifica las credenciales.",
    networkError: "Error de red al probar la conexión",
    invalidCredentials: "Credenciales inválidas",
    noTenantSelected: "No hay tenant seleccionado",
    processing: "Procesando...",
    reconnect: "Reconectar",
    apiKeys: "API Keys",
    inDevelopment: "Página de integraciones en desarrollo.",
    connectedLabel: "conectadas",
    totalLabel: "integraciones",
    failedLabel: "con error",
    clearSearch: "Limpiar búsqueda",
    available: "Disponibles",
    connectWhatsApp: "Conectar WhatsApp",
    showValue: "Mostrar valor",
    hideValue: "Ocultar valor",
    officialDocs: "Documentación oficial",

    woocommerce: {
      oauthRecommended: "OAuth (Recomendado)",
      apiKeysAlternative: "API Keys (Alternativa)",
      oauthTitle: "Conexión con OAuth (1 clic)",
      oauthDescription: "Solo necesitas la URL de tu tienda. Serás redirigido a WooCommerce para autorizar la conexión.",
      apiKeysTitle: "Conexión con API Keys",
      apiKeysDescription: "Usa API Keys si tu tienda no tiene SSL o prefieres este método.",
      siteUrl: "URL de la tienda",
      consumerKey: "Consumer Key",
      consumerSecret: "Consumer Secret",
    },

    instructions: {
      woocommerce: {
        title: "Conectar WooCommerce - Dos formas",
        steps: "🔐 OAuth (Recomendado):\n• Ingresa la URL de tu tienda\n• Haz clic en \"Conectar\"\n• Serás redirigido a WooCommerce para autorizar\n\n🔑 API Keys (Alternativa):\n• Ve a WooCommerce → Ajustes → Avanzado → API REST\n• Crea una clave API con permisos de Lectura/Escritura\n• Copia Consumer Key y Consumer Secret",
      },
      shopify: {
        title: "Cómo conectar Shopify",
        steps: "1. Ingresa el dominio de tu tienda (ej: tu-tienda.myshopify.com)\n2. Haz clic en \"Conectar\"\n3. Serás redirigido a Shopify\n4. Inicia sesión con tu cuenta de administrador\n5. Haz clic en \"Instalar aplicación\" para autorizar\n6. ¡Listo! Serás redirigido automáticamente",
      },
      'whatsapp-business': {
        title: "Cómo obtener credenciales de WhatsApp Business",
        steps: "1. Ve a https://developers.facebook.com/apps/\n2. Crea una aplicación de tipo \"Business\"\n3. Activa el producto \"WhatsApp\"\n4. Configura un número de teléfono en \"API Setup\"\n5. Copia el \"Phone Number ID\"\n6. Copia el \"Access Token\" (temporal)",
      },
      stripe: {
        title: "Cómo obtener tu clave de Stripe",
        steps: "1. Ve a tu dashboard de Stripe\n2. Ve a \"Desarrolladores\" → \"Claves API\"\n3. Copia la \"Clave secreta\" (sk_live_... o sk_test_...)\n4. Pégala en el campo de abajo",
      },
      paypal: {
        title: "Cómo obtener credenciales de PayPal",
        steps: "1. Ve a https://developer.paypal.com/\n2. Inicia sesión con tu cuenta de PayPal\n3. Ve a \"My Apps & Credentials\"\n4. Crea una aplicación REST API\n5. Copia el \"Client ID\" y \"Secret\"",
      },
      mailchimp: {
        title: "Cómo obtener tu API Key de Mailchimp",
        steps: "1. Ve a tu cuenta de Mailchimp\n2. Haz clic en tu foto de perfil → \"Cuenta\"\n3. Ve a \"Extras\" → \"Claves API\"\n4. Crea una nueva clave API\n5. Copia la clave y el server prefix (ej: us5)",
      },
      'google-calendar': {
        title: "Conectar Google Calendar",
        steps: "1. Haz clic en \"Conectar\"\n2. Serás redirigido a Google\n3. Inicia sesión con tu cuenta de Google\n4. Autoriza los permisos de Calendar\n5. ¡Listo! Tus eventos se sincronizarán",
      },
      gmail: {
        title: "Conectar Gmail",
        steps: "1. Haz clic en \"Conectar\"\n2. Serás redirigido a Google\n3. Inicia sesión con tu cuenta de Gmail\n4. Autoriza los permisos de lectura/escritura\n5. ¡Listo! Tus correos se sincronizarán",
      },
    },

    helpLinks: {
      shopify: { shopDomain: "¿Cómo encontrar mi dominio?" },
      woocommerce: {
        siteUrl: "¿Dónde está mi URL?",
        consumerKey: "¿Cómo generar Consumer Key?",
        consumerSecret: "¿Cómo generar Consumer Secret?",
      },
      'whatsapp-business': {
        phoneNumberId: "¿Cómo obtener Phone Number ID?",
        accessToken: "¿Cómo obtener Access Token?",
      },
      stripe: { secretKey: "¿Dónde está mi Secret Key?" },
      paypal: {
        clientId: "¿Dónde encontrar Client ID?",
        secret: "¿Dónde encontrar Secret?",
      },
      mailchimp: {
        apiKey: "¿Cómo obtener API Key?",
        server: "¿Qué es Server Prefix?",
      },
      klaviyo: {
        publicKey: "¿Dónde está mi Public Key?",
        privateKey: "¿Dónde está mi Private Key?",
      },
      zendesk: {
        subdomain: "¿Qué es el subdominio?",
        email: "¿Qué email usar?",
        apiToken: "¿Cómo generar API Token?",
      },
      livechat: {
        licenseId: "¿Dónde está mi License ID?",
        apiKey: "¿Cómo obtener API Key?",
      },
      prestashop: {
        url: "¿Qué URL usar?",
        apiToken: "¿Cómo generar API Token?",
      },
      cmi: {
        merchantId: "Contacta con CMI para obtener tu Merchant ID",
        hmacKey: "Te proporcionarán una HMAC Key",
      },
      zapier: { hookUrl: "¿Cómo crear un webhook en Zapier?" },
    },

    categories: {
      all: "Todas",
      messaging: "Mensajería",
      ecommerce: "eCommerce",
      crm: "CRM",
      productivity: "Productividad",
      payment: "Pagos",
      other: "Otros",
    },
  },

  settings: {
    title: "Ajustes",
    subtitle: "Configura tu cuenta, negocio y facturación.",

    tabs: {
      company: "Empresa",
      privacy: "Privacidad",
      payments: "Pagos",
      billing: "Facturación",
      plan: "Plan",
      employees: "Empleados",
      business: "Negocio",
    },

    company: {
      sectionTitle: "Datos de la empresa",
      panelLanguage: "Idioma del panel",
      name: "Nombre de la empresa",
      rc: "RC",
      ice: "ICE",
      phone: "Teléfono",
      email: "Email",
      address: "Dirección",
      website: "Website",
      country: "País del negocio",
    },

    privacy: {
      usersAccess: "Usuarios y acceso",
      usersAccessHint: "Controla quién puede acceder a esta cuenta.",
      inviteUser: "Invitar usuario",
      invitePlaceholder: "email@ejemplo.com",
      role: "Rol",
      invite: "Invitar",
      email: "Email",
      actions: "Acciones",
      remove: "Quitar",
      empty: "Sin usuarios aún.",
      security: "Seguridad",
      force2fa: "Forzar 2FA",
      disabled: "Desactivado",
      requiredAdmins: "Obligatorio para Admin/Owner",
      requiredAll: "Obligatorio para todos",
      sessionExpiry: "Vencimiento de sesión",
      days7: "7 días",
      days30: "30 días",
      days90: "90 días",
      resetPasswords: "Restablecer contraseñas",
      sendReset: "Enviar emails de reset",
      recommended2fa: "Recomendado: 2FA obligatorio al menos para Admin/Owner.",
      loadingUser: "Cargando usuario...",
      cannotIdentifyTenant: "No se pudo identificar el tenant",
      changePassword: "Cambiar contraseña",
      currentPassword: "Contraseña actual",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar contraseña",
      allFieldsRequired: "Todos los campos son obligatorios",
      passwordsDontMatch: "Las nuevas contraseñas no coinciden",
      passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
      passwordUpdated: "¡Contraseña actualizada exitosamente!",
      noInvitePermission: "No tienes permisos para invitar nuevos miembros.",
      upgradePlan: "Actualiza tu plan",
    },

    payments: {
      method: "Método de pago",
      openPortal: "Abrir portal seguro",
      desc: "Gestiona tarjeta y facturación en un portal seguro (PCI DSS) — p.ej. Stripe Customer Portal.",
      currentMethod: "Método actual",
      holder: "Titular",
      loadingTenant: "Cargando información del tenant...",
      errorOpeningPortal: "Error al abrir portal",
      noPortalUrl: "No portal URL received",
      noPaymentMethods: "No hay métodos de pago configurados",
      default: "Predeterminada",
      expires: "Expira",
      manageInStripe: "Gestionar en Stripe",
    },

    billing: {
      history: "Histórico de facturas",
      none: "Sin facturas todavía.",
      count: "Facturas",
    },

    plan: {
      current: "Tu plan actual",
      plan: "Plan",
      minutes: "Minutos usados (mes)",
      renewal: "Renovación",
      loadingUser: "Cargando usuario...",
      noAuthenticatedUser: "No hay usuario autenticado",
      userHasNoTenant: "El usuario no tiene tenant asignado",
      cannotIdentifyTenant: "No se pudo identificar el tenant",
      errorCreatingCheckout: "Error al crear checkout",
      noCheckoutUrl: "No checkout URL received",
      errorOpeningPortal: "Error al abrir portal",
      noPortalUrl: "No portal URL received",
      subscriptionUpdated: "¡Suscripción actualizada correctamente!",
      currentPlan: "Actual",
      manage: "Gestionar",
      price: "Precio",
      available: "Planes disponibles",
      select: "Seleccionar",
      noPlan: "No tienes ningún plan activo.",
    },

    employees: {
      manage: "Gestionar empleados",
      name: "Nombre",
      position: "Puesto",
      phone: "Teléfono",
      add: "Añadir",
      actions: "Acciones",
      delete: "Borrar",
      empty: "Sin empleados todavía.",
    },

    business: {
      params: "Parámetros del negocio",
      type: "Tipo de negocio (clave)",
      category: "Categoría / Subtipo (clave)",
      timezone: "Timezone",
      tables: "Número de mesas",
      capacity: "Aforo (personas)",
      applyAll: "Aplicar horario a todos",
      hours: "Horarios",
      open: "Abierto",
      opensAt: "Abre",
      closesAt: "Cierra",
    },
  },

  dow: {
    mon: "Lun",
    tue: "Mar",
    wed: "Mié",
    thu: "Jue",
    fri: "Vie",
    sat: "Sáb",
    sun: "Dom",
  },

  business: {
    type: {
      restaurant: "Restaurante",
      cafe: "Café",
      bar: "Bar / Nightlife",
      hotel: "Hotel",
      spa: "Spa",
      clinic: "Clínica",
      salon: "Salón / Beauty",
      gym: "Gimnasio",
      retail: "Retail / Tienda",
      ecommerce: "eCommerce",
      services: "Servicios",
      real_estate: "Inmobiliaria",
      other: "Otro",
    },
  },

  ai: {
    title: "IA Assistant",
    settings: "Configuración de IA",
    context: "Contexto del negocio",
    restaurantProfile: "Perfil del restaurante",
    voiceAssistant: "Asistente de voz",
    fileUpload: "Subir archivos",
    messages: "Conversaciones",
    training: "Entrenamiento",
    suggestions: "Sugerencias",
    generate: "Generar",
    regenerating: "Generando...",
    prompt: "Prompt",
    response: "Respuesta",
    copy: "Copiar",
    copied: "Copiado",
    unblockAI: "Desbloquear AI",
    blockAI: "Bloquear AI",
    blockedManually: "Bloqueado manualmente",
  },

  restaurant: {
    editor: "Editor de Restaurante",
    loading: "Cargando datos del restaurante...",
    readOnly: "Solo lectura",
    lastSaved: "Último guardado",
    editMode: "Modo edición",
    preview: "Vista previa",
    profilePreview: "Vista previa del perfil",
    saveChanges: "Guardar cambios",
    notSpecified: "No especificado",
    cuisineType: "Tipo de cocina",
    checkInPerson: "Consultar en el local",
    liveRoom: "Sala en vivo",
    soon: "PRONTO",
    inRoom: "EN SALA",
    newCustomer: "Nuevo cliente",
    assignTable: "Asignar mesa",
    waitlist: "Lista de espera",
    addToWaitlist: "Añadir a espera",
    noFreeTables: "Sin mesas libres para {{pax}} personas",
    view: "vista",
    list: "Lista",
    map: "Mapa",
    swipeHint: "Mesas · desliza ← → para cambiar estado",
    upcoming: "Próximas",
    noUpcomingBookings: "Sin reservas próximas",
    tapToMarkArrival: "Toca para marcar llegada",
    hotTables: "Mesas calientes",
    emptyList: "Lista vacía",
    noActivity: "Sin actividad",
    table: "Mesa",
    general: "General",
    location: "Ubicación",
    schedule: "Horarios",
    tables: "Mesas",
    features: "Características",
    celebrations: "Celebraciones",
    menu: "Menú",
    policies: "Políticas",
    publish: "Publicar",
    unpublish: "Despublicar",
    published: "Publicado",
    draft: "Borrador",
    capacity: "Capacidad",
    combinable: "Combinable",
    zones: "Zonas",

    status: {
      free: "Libre",
      reserved: "Reservada",
      occupied: "Ocupada",
      cleaning: "Limpieza",
    },

    errors: {
      cannotResolveTenant: "No se pudo resolver el tenant actual.",
      loginAgain: "Vuelve a iniciar sesión y prueba de nuevo.",
    },

    generalSection: {
      title: "Información General",
      name: "Nombre del restaurante",
      namePlaceholder: "Ej: Restaurante El Rincón",
      phone: "Teléfono",
      phonePlaceholder: "+212 600 000000",
      email: "Email",
      emailPlaceholder: "info@restaurante.com",
      founded: "Año fundación",
      foundedPlaceholder: "1998",
      capacity: "Capacidad",
      capacityPlaceholder: "80",
      description: "Descripción",
      descriptionPlaceholder: "Describe el restaurante, su historia y propuesta...",
      social: "Redes sociales",
      facebookPlaceholder: "facebook.com/...",
      instagramPlaceholder: "@usuario",
      xPlaceholder: "@usuario",
      classification: "Clasificación",
      cuisine: "Tipo de cocina",
      dietary: "Opciones dietéticas",
      ambience: "Ambiente",
      specialties: "Especialidades del chef",
      certifications: "Certificaciones",
      owner: "Propietario / Chef",
      ownerName: "Nombre",
      ownerNamePlaceholder: "Ej: Juan Pérez",
      ownerBio: "Biografía",
      ownerBioPlaceholder: "Historia del chef...",
      funFacts: "Anécdotas y curiosidades",
      funFactsPlaceholder: "Ej: La receta secreta lleva más de 50 años en la familia...",
    },

    certifications: {
      halal: "Halal",
      organic: "Orgánico",
      sustainable: "Sostenible",
      michelin: "Michelin",
      glutenFree: "Sin Gluten",
      vegan: "Vegano",
      vegetarian: "Vegetariano",
    },

    schedule: {
      venueHours: "Horario del local",
      copyMonday: "Copiar lunes a todos",
      closed: "Cerrado",
      morning: "Mañana / Mediodía",
      evening: "Tarde / Noche",
      notApplicable: "No aplica",
      kitchenHours: "Horario de cocina",
      closedKitchen: "Cerrada",
      mealServices: "Servicios de comida",
      breakfast: "Desayuno",
      brunch: "Brunch",
      lunch: "Almuerzo",
      dinner: "Cena",
      lateNight: "After hours",
      twoDinnerShifts: "Dos turnos de cena",
      firstShift: "1er turno",
      secondShift: "2º turno",
      holidays: "Días festivos y cierres especiales",
      noHolidays: "Sin festivos configurados",
      holidayReason: "Motivo (Navidad, Ramadán...)",
      seasonalHours: "Horarios por temporada",
      summer: "Verano",
      winter: "Invierno",
      ramadan: "Ramadán",
    },

    features: {
      venueFeatures: "Características del local",
      accessibility: "Accesibilidad",
      services: "Servicios",
      paymentMethods: "Métodos de pago",
      soundEnvironment: "Ambiente sonoro",
      hasBackgroundMusic: "Hay música de fondo",
      mainGenres: "Géneros principales",
      volumeLevel: "Nivel de volumen habitual",
      liveMusic: "Música en vivo",
      frequency: "Frecuencia",
      liveMusicTypes: "Tipos de música en vivo",
      approximateSchedule: "Horarios aproximados",
      schedulePlaceholder: "Ej: viernes y sábados 20:00-23:00",
      atmosphere: "Ambiente y clima",
      roomTemperature: "Temperatura ambiente",
      climateSystem: "Sistema de climatización",
      lighting: "Ambiente lumínico",
      outdoorSeating: "Terraza exterior",
      heatedTerrace: "Terraza climatizada",
      fans: "Ventiladores",
      entertainment: "Entretenimiento",
      sustainability: "Sostenibilidad",
      technology: "Tecnología",

      volumeLevels: {
        quiet: "Bajo / conversación",
        medium: "Medio",
        loud: "Alto",
      },
      frequencies: {
        daily: "Todos los días",
        weekends: "Fines de semana",
        weekly: "Una vez por semana",
        occasional: "Ocasional / eventos especiales",
      },
      temperature: {
        cold: "Frío (aire acondicionado fuerte)",
        comfortable: "Confortable (21-23°C)",
        warm: "Cálido (calefacción)",
        variable: "Variable según zona",
      },
      climateSystem: {
        ac: "Aire acondicionado",
        heating: "Calefacción",
        both: "Ambos",
        natural: "Solo ventilación natural",
      },
      lighting: {
        bright: "Iluminación brillante",
        ambient: "Luz ambiental",
        dim: "Luz tenue / romántico",
        adjustable: "Ajustable por zona",
      },
      techItems: {
        qrMenus: "Menús QR",
        ownApp: "App propia",
        nfcPayment: "Pagos NFC",
        digitalWaitlist: "Lista de espera digital",
      },
    },

    celebrations: {
      title: "Celebraciones y eventos especiales",
      birthdayCake: "Tarta de cumpleaños",
      price: "Precio",
      numberOfPeople: "Número de personas",
      specialPackages: "Paquetes especiales",
      addPackage: "Añadir paquete",
      noPackages: "Sin paquetes configurados",
      packageName: "Nombre del paquete",
      packageDescription: "Descripción del paquete",
      description: "Descripción",
      options: {
        birthday: "Cumpleaños",
        anniversary: "Aniversario",
        engagement: "Pedida de mano",
        business: "Comida de empresa",
        graduation: "Graduación",
        other: "Otros",
      },
    },

    menu: {
      importWithAI: "Importar menú con IA",
      importDescription: "Importa tu carta desde un PDF, foto, Word o Excel. La IA extraerá automáticamente las categorías, platos, precios y alérgenos.",
      supportedFormats: "Formatos soportados: PDF, JPG, PNG, DOCX, XLSX · Máx. 10MB",
      processing: "Procesando…",
      importMenu: "Importar carta",
      ocrHint: "La importación OCR detectará el idioma automáticamente y la IA normalizará los nombres y precios.",
      categories: "Categorías",
      newCategory: "Nueva categoría",
      editCategory: "Editar categoría",
      noCategories: "Sin categorías. Crea una o importa tu carta.",
      categoryNamePlaceholder: "Ej: Entrantes, Carnes, Postres...",
      categoryDescriptionPlaceholder: "Descripción opcional de la categoría",
      categoryUpdated: "Categoría actualizada",
      categoryCreated: "Categoría creada",
      categoryDeleted: "Categoría eliminada",
      confirmDeleteCategory: "¿Eliminar esta categoría y todos sus platos?",
      dishes: "Platos",
      newDish: "Nuevo plato",
      editDish: "Editar plato",
      loadingDishes: "Cargando platos…",
      noDishes: "Sin platos en esta categoría.",
      dishName: "Nombre del plato",
      dishNamePlaceholder: "Ej: Ensalada César",
      dishDescriptionPlaceholder: "Ingredientes principales, preparación...",
      category: "Categoría",
      noCategory: "Sin categoría",
      preparationTime: "Preparación (min)",
      calories: "Calorías (kcal)",
      dietaryOptions: "Opciones dietéticas",
      dishUpdated: "Plato actualizado",
      dishCreated: "Plato creado",
      dishDeleted: "Plato eliminado",
      confirmDeleteDish: "¿Eliminar este plato?",
      processingError: "Error procesando archivo",
      importError: "Error al importar",
      menuImported: "Menú importado: {{categories}} categorías, {{items}} platos",
      unnamed: "Sin nombre",

      dietary: {
        vegetarian: "Vegetariano",
        vegan: "Vegano",
        glutenFree: "Sin gluten",
        spicy: "Picante",
      },

      allergens: {
        title: "Alérgenos",
        gluten: "Gluten",
        crustaceans: "Crustáceos",
        eggs: "Huevos",
        fish: "Pescado",
        peanuts: "Cacahuetes",
        soy: "Soja",
        dairy: "Lácteos",
        nuts: "Frutos cáscara",
        celery: "Apio",
        mustard: "Mostaza",
        sesame: "Sésamo",
        sulfites: "Sulfitos",
        lupin: "Altramuces",
        mollusks: "Moluscos",
      },
    },

    policies: {
      bookingPolicies: "Políticas de reserva",
      cancellationHours: "Cancelación — horas antes",
      noShowPenalty: "Penalización no-show (%)",
      deposit: "Depósito",
      perPerson: "Por persona",
      tableHoldTime: "Retención de mesa (min)",
      restrictions: "Restricciones",
      minorsAllowed: "Menores permitidos",
      minorsAccompanied: "Menores acompañados",
      adultsOnly: "Solo adultos (+18)",
      petsAllowed: "Mascotas permitidas",
      serviceAnimals: "Perros guía",
      smokingArea: "Zona fumadores",
      smokingTerrace: "Terraza fumadores",
      dressCode: "Código de vestimenta",
      groupsWelcome: "Grupos bienvenidos",
      dressCodeTitle: "Código de vestimenta",
      dressCodeType: "Tipo de código",
      noDressCode: "Sin código específico",
      casual: "Casual / Informal",
      smartCasual: "Smart Casual",
      elegante: "Elegante",
      formal: "Formal (traje)",
      traditional: "Tradicional",
      dressCodePlaceholder: "Ej: Se requiere vestimenta elegante, caballeros con chaqueta...",
      groupPolicies: "Políticas para grupos",
      minGroupSize: "Mínimo personas para grupo",
      advanceNotice: "Antelación requerida (horas)",
      specialGroupPolicy: "Política especial para grupos",
      specialGroupPolicyPlaceholder: "Ej: Menú cerrado obligatorio, depósito del 30%...",
      children: "Niños",
      kidsMenu: "Menú infantil",
      notAvailable: "No disponible",
      available: "Disponible",
      customizable: "Menú personalizable",
      childAgeLimit: "Edad considerada niño (años)",
      highChairs: "Tronas disponibles",
      changingTable: "Cambiador en baños",
      playArea: "Área de juegos",
      pets: "Mascotas",
      petPolicy: "Política de mascotas",
      noPets: "No se permiten mascotas",
      serviceAnimalsOnly: "Solo perros guía",
      teraceOnly: "Solo en terraza",
      allAllowed: "Permitidas en todo el local",
      waterBowl: "Cuenco de agua disponible",
      treats: "Snacks para mascotas",
      health: "Salud",
      masksRequired: "Mascarillas requeridas",
      vaccinationRequired: "Vacunación requerida",
      maxCapacity: "Capacidad máxima",
      capacityPlaceholder: "Ej: 50",
      inclusivity: "Inclusividad",
      lgbtqFriendly: "LGBTQ+ friendly",
      accessibleAll: "Accesible para todos",
      diversityStatement: "Declaración de diversidad",
      diversityPlaceholder: "Ej: Damos la bienvenida a todos sin importar...",
      legalTerms: "Términos legales",
      privacyPolicy: "Política de privacidad (URL o texto)",
      privacyPlaceholder: "https://... o texto de la política",
      termsAndConditions: "Términos y condiciones",
      termsPlaceholder: "Términos y condiciones de reserva...",
      gdprCompliant: "Cumple con GDPR (protección de datos UE)",
    },
  },

  automations: {
    title: "Automatizaciones",
    subtitle: "Conecta eventos con acciones automáticas sin código.",
    newAutomation: "Nueva automatización",
    new: "Nueva",
    active: "Activa",
    inactive: "Inactiva",
    test: "Probar",
    testing: "Probando…",
    testSuccess: "Prueba ejecutada correctamente ✅",
    testError: "Error en la prueba",
    noAutomations: "Sin automatizaciones",
    noAutomationsDesc: "Crea tu primera automatización o usa una plantilla para empezar rápido.",
    viewTemplates: "Ver plantillas",
    createFromScratch: "Crear desde cero",
    generateWithAI: "Generar con IA",
    use: "Usar",
    deleteTitle: "¿Eliminar automatización?",
    deleteConfirm: "Esta acción no se puede deshacer.",
    when: "CUANDO",
    before: "antes",
    delay: "delay",
    addStep: "Añadir paso",
    selectTrigger: "Selecciona el evento que dispara esta automatización:",
    whenThisHappens: "Cuando ocurra esto…",
    executeTheseActions: "Ejecutar estas acciones:",
    requiresTimeConfig: "Requiere configuración de tiempo",
    willSend: "Se enviará",
    beforeBooking: "antes de la reserva",
    ofWait: "de espera",
    automationName: "Nombre de la automatización",
    clickToInsert: "Haz clic en una variable para insertarla:",
    example: "Ejemplo",

    categories: {
      ecommerce: "E-commerce",
      bookings: "Reservas",
      messages: "Mensajes",
      crm: "CRM",
      marketing: "Marketing",
      advanced: "Avanzado",
      control: "Control",
    },

    triggers: {
      newOrderWoo: "Nuevo pedido (WooCommerce)",
      newOrderWooDesc: "Se activa cuando se recibe un nuevo pedido en tu tienda.",
      orderUpdatedWoo: "Pedido actualizado (WooCommerce)",
      orderUpdatedWooDesc: "Se activa cuando cambia el estado de un pedido existente.",
      bookingReminder: "Recordatorio de reserva",
      bookingReminderDesc: "Envía un aviso al cliente antes de su reserva. Tú eliges cuánto antes.",
      newBookingConfirmed: "Nueva reserva confirmada",
      newBookingConfirmedDesc: "Se activa cuando se crea una nueva reserva en el sistema.",
      newWhatsAppMessage: "Nuevo mensaje de WhatsApp",
      newWhatsAppMessageDesc: "Se activa cuando un cliente envía un mensaje por WhatsApp.",
      incomingWebhook: "Webhook entrante",
      incomingWebhookDesc: "Se activa cuando recibes una petición HTTP externa.",
      crmContactCreated: "Contacto creado",
      crmContactCreatedDesc: "Se activa cuando se crea un nuevo contacto en el CRM.",
      crmContactUpdated: "Contacto actualizado",
      crmContactUpdatedDesc: "Se activa cuando se actualiza cualquier dato de un contacto.",
      crmLifecycleChanged: "Etapa de vida cambiada",
      crmLifecycleChangedDesc: "Se activa cuando cambia la etapa (Lead, Prospecto, etc) de un contacto.",
      crmDealCreated: "Oportunidad creada",
      crmDealCreatedDesc: "Se activa cuando se crea una nueva oportunidad de venta.",
      crmDealStageChanged: "Etapa de oportunidad cambiada",
      crmDealStageChangedDesc: "Se activa cuando una oportunidad se mueve de etapa.",
      crmNoteCreated: "Nota creada",
      crmNoteCreatedDesc: "Se activa cuando se añade una nota manual a un contacto.",
    },

    variables: {
      orderId: "Número de pedido",
      orderTotal: "Total del pedido",
      orderStatus: "Estado del pedido",
      newStatus: "Nuevo estado",
      customerName: "Nombre del cliente",
      customerPhone: "Teléfono del cliente",
      customerEmail: "Email del cliente",
      productNames: "Productos del pedido",
      phone: "Teléfono",
      bookingDate: "Fecha de la reserva",
      bookingTime: "Hora de la reserva",
      time: "Hora",
      people: "Número de personas",
      reference: "Referencia",
      messageText: "Texto del mensaje",
      webhookData: "Datos del webhook",
      contactId: "ID del contacto",
      dealId: "ID de la oportunidad",
      oldStage: "Etapa anterior",
      newStage: "Nueva etapa",
      noteBody: "Contenido de la nota",
      tagName: "Nombre de la etiqueta",
    },

    fields: {
      sendBefore: "Enviar con cuánta antelación",
      timeUnit: "Unidad de tiempo",
      templateName: "Nombre de la plantilla",
      language: "Idioma",
      jsonBody: "Body JSON (opcional)",
      wait: "Esperar",
      unit: "Unidad",
    },

    units: {
      minutesBefore: "Minutos antes",
      hoursBefore: "Horas antes",
      daysBefore: "Días antes",
      minutes: "Minutos",
      hours: "Horas",
      days: "Días",
      short: {
        minutes: "min",
        hours: "h",
        days: "d",
      },
    },

    languages: {
      spanish: "Español",
      french: "Francés",
      english: "Inglés",
      arabic: "Árabe",
    },

    actions: {
      sendWhatsApp: "Enviar mensaje de WhatsApp",
      sendWhatsAppDesc: "Envía un mensaje de texto libre por WhatsApp.",
      sendTemplate: "Enviar plantilla",
      sendTemplateDesc: "Envía una plantilla oficial de WhatsApp.",
      crmAddTag: "Añadir etiqueta",
      crmAddTagDesc: "Añade una etiqueta específica al contacto.",
      crmSetLifecycle: "Cambiar etapa de vida",
      crmSetLifecycleDesc: "Cambia la etapa (Lead, Cliente, etc) del contacto.",
      crmAddNote: "Añadir nota",
      crmAddNoteDesc: "Añade una nota interna al timeline del contacto.",
      crmCreateDeal: "Crear oportunidad",
      crmCreateDealDesc: "Crea una nueva oportunidad de venta asociada al contacto.",
      mktSendTemplate: "Enviar plantilla Marketing",
      mktSendTemplateDesc: "Envía una plantilla de marketing por el canal preferido.",
      callExternalUrl: "Llamar a URL externa",
      callExternalUrlDesc: "Hace una petición HTTP POST a un endpoint externo.",
      wait: "Esperar un tiempo",
      waitDesc: "Pausa X minutos/horas/días antes de la siguiente acción",
    },

    placeholders: {
      example2: "Ej: 2",
      example7: "Ej: 7",
      messageExample: "Ej: ¡Hola {{nombre_cliente}}! Te recordamos tu reserva del {{fecha_reserva}} a las {{hora_reserva}} ✅",
    },

    templates: {
      title: "Plantillas de automatización",
      orderConfirmation: "Confirmación de pedido",
      orderConfirmationDesc: "Cuando llega un pedido nuevo, envía confirmación automática por WhatsApp.",
      reminder2h: "Recordatorio reserva 2h antes",
      reminder2hDesc: "Avisa al cliente 2 horas antes de su reserva.",
      reminder1d: "Recordatorio reserva 1 día antes",
      reminder1dDesc: "Avisa al cliente el día anterior a su reserva.",
      orderShipped: "Pedido enviado → aviso WhatsApp",
      orderShippedDesc: "Cuando un pedido pasa a \"procesando\", notifica al cliente.",
      review7d: "Review 7 días después del pedido",
      review7dDesc: "Solicita una valoración una semana después de la compra.",
    },

    templateMessages: {
      orderConfirmation: "¡Hola {{customer_name}}! 🎉\n\nHemos recibido tu pedido {{order_id}}.\n\n🛍️ Productos: {{product_names}}\n💰 Total: {{order_total}}\n\nTe avisaremos cuando esté en camino. ¡Gracias por tu compra!",
      reminder2h: "¡Hola {{nombre_cliente}}! 👋\n\nTe recordamos tu reserva de hoy a las *{{hora_reserva}}* para {{personas}} personas.\n\nSi necesitas modificar algo, responde a este mensaje.\n\n¡Hasta pronto! 🍽️",
      reminder1d: "¡Hola {{nombre_cliente}}! 😊\n\nTe recordamos que mañana *{{fecha_reserva}}* tienes una reserva a las *{{hora_reserva}}* para {{personas}} personas.\n\nRef: {{referencia}}\n\n¿Necesitas cancelar o modificar? Escríbenos aquí.",
      orderShipped: "¡Hola {{customer_name}}! 📦\n\nTu pedido {{order_id}} está siendo preparado.\nEn breve recibirás más información sobre el envío.",
      review7d: "¡Hola {{customer_name}}! ⭐\n\nEsperamos que estés disfrutando de tu pedido {{order_id}}.\n\n¿Podrías dejarnos una valoración? Tu opinión nos ayuda mucho. ¡Gracias!",
    },

    errors: {
      selectTrigger: "Selecciona un trigger",
      addAtLeastOneAction: "Añade al menos una acción (no solo un delay)",
      configureReminder: "Configura la antelación del recordatorio (cantidad y unidad)",
      saveFailed: "Error al guardar",
      unknownError: "Error desconocido",
      saveFirst: "Guarda primero la automatización",
    },

    aiAssistant: "Asistente IA",
    aiDescription: "Describe tu automatización en lenguaje natural",
    aiWhatToAutomate: "¿Qué quieres automatizar?",
    aiPlaceholder: "Ej: Enviar un WhatsApp al cliente 7 días después de su pedido pidiéndole una review...",
    aiEnterHint: "Pulsa Enter para generar · Shift+Enter para nueva línea",
    aiExampleRequests: "Ejemplos de peticiones",
    aiGenerating: "Generando…",
    aiProcessing: "Mistral está procesando tu petición",
    aiGenerated: "Automatización generada",
    aiReviewHint: "Revisa el mensaje generado y ajústalo antes de activar la automatización.",
    aiNewRequest: "Nueva petición",
    aiUseThis: "Usar esta automatización",
    aiGenerate: "Generar",

    aiSuggestions: {
      confirmation: "Enviar WhatsApp de confirmación cuando llega un pedido nuevo",
      reminder2h: "Recordar la reserva al cliente 2 horas antes",
      review7d: "Pedir una review 7 días después del pedido",
      processing: "Avisar al cliente cuando su pedido cambia a \"procesando\"",
      welcome: "Mensaje de bienvenida cuando llega un nuevo mensaje de WhatsApp",
      reminder1d: "Recordatorio de reserva el día anterior",
    },

    aiErrors: {
      generationFailed: "Error al generar la automatización",
      connectionError: "Error de conexión. Comprueba que el servidor está activo.",
    },

    waitDays: "Esperar {{count}} día(s)",
    waitHours: "Esperar {{count}} hora(s)",
    waitMinutes: "Esperar {{count}} minuto(s)",
  },

  freelance: {
    manager: "Gestor freelance",
    profile: "Mi perfil",
    availability: "Disponibilidad",
    services: "Servicios",
    media: "Medios",
    schedule: "Horario",
    general: "General",
    physicalCharacteristics: "Características físicas",
    chat: "Chat",
    preview: "Vista previa",
  },

  products: {
    title: "Productos",
    all: "Todos los productos",
    active: "Activos",
    inactive: "Inactivos",
    outOfStock: "Sin stock",
    lowStock: "Stock bajo",
    categories: "Categorías",
    price: "Precio",
    stock: "Stock",
    sku: "SKU",
    variants: "Variantes",
    attributes: "Atributos",
    description: "Descripción",
    images: "Imágenes",
    addProduct: "Añadir producto",
    editProduct: "Editar producto",
  },

  billing: {
    title: "Facturación",
    invoices: "Facturas",
    paymentMethods: "Métodos de pago",
    subscription: "Suscripción",
    currentPlan: "Plan actual",
    changePlan: "Cambiar plan",
    cancelPlan: "Cancelar plan",
    billingHistory: "Historial de facturación",
    downloadInvoice: "Descargar factura",
    amount: "Importe",
    date: "Fecha",
    status: "Estado",
    paid: "Pagado",
    unpaid: "Pendiente",
    overdue: "Vencido",
  },

  support: {
    contactSupport: "Contactar soporte",
    submitTicket: "Enviar ticket",
    ticketHistory: "Historial de tickets",
    faq: "Preguntas frecuentes",
    chat: "Chat en vivo",
    email: "Email soporte",
    phone: "Teléfono soporte",
    priority: "Prioridad",
    low: "Baja",
    medium: "Media",
    high: "Alta",
    urgent: "Urgente",
    subject: "Asunto",
    message: "Mensaje",
    attachments: "Adjuntos",
    submit: "Enviar",
    submitted: "Enviado",
  },

  notifications: {
    title: "Notificaciones",
    all: "Todas",
    unread: "No leídas",
    markAllRead: "Marcar todas como leídas",
    clearAll: "Limpiar todas",
    empty: "Sin notificaciones",
    settings: "Configuración de notificaciones",
    emailNotifications: "Notificaciones por email",
    pushNotifications: "Notificaciones push",
    sound: "Sonido",
    desktop: "Escritorio",
    mobile: "Móvil",
  },

  calls: {
    title: "Llamadas",
    calls: "Llamadas",
    searchPlaceholder: "Buscar por ID, número o intent…",
    reset: "Reset",
    intent: "Intent",
    table: {
      id: "ID",
      from: "De",
      to: "A",
      duration: "Duración",
      toLabel: "A",
    },
    intents: {
      booking: "Reserva",
      menu: "Menú",
      complaint: "Reclamación",
      schedule: "Horario",
      location: "Ubicación",
      payment: "Pago",
      menuLetter: "Carta",
    },
    status: {
      ok: "OK",
      ongoing: "En curso",
      failed: "Fallida",
    },
    comingSoon: {
      title: "Llamadas con IA",
      description: "Esta sección estará disponible próximamente. Podrás ver, filtrar y analizar todas tus llamadas gestionadas por IA.",
      badge: "Próximamente",
    },
    call: "Llamada",
    detailSubtitle: "Resumen y transcripción de la llamada.",
    backToList: "Volver a llamadas",
    participants: "Participantes",
    audio: "Audio",
    download: "Descargar",
    noAudio: "No hay audio disponible para esta llamada.",
    transcript: "Transcripción",
    assistant: "Asistente",
    user: "Usuario",
    metadata: "Metadatos",
    processedMeta: "Procesado STT→GPT→TTS: ~620ms",
    audioQuality: "Calidad audio: 8k μ-law",
    detectedLanguage: "Lengua detectada: es/darija",
  },

  errors: {
    somethingWentWrong: "Algo salió mal",
    tryAgain: "Intentar de nuevo",
    pageNotFound: "Página no encontrada",
    unauthorized: "No autorizado",
    forbidden: "Acceso prohibido",
    serverError: "Error del servidor",
    networkError: "Error de red",
    validationError: "Error de validación",
    required: "Este campo es requerido",
    invalidEmail: "Email inválido",
    invalidPhone: "Teléfono inválido",
    minLength: "Mínimo {{min}} caracteres",
    maxLength: "Máximo {{max}} caracteres",
    passwordMismatch: "Las contraseñas no coinciden",
    tenantNotFound: "No se pudo identificar el tenant. Recarga la página.",
  },
} as const;

export default es;
